













































import Vue from 'vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxScrolling, DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import {FETCH_PRINTING_ACTIVITY_LIST} from '@/store/action-types'
import AddressWindow from '@/components/master-data/address/AddressWindow.vue'
import {PrintingActivityResponse} from '@/types/service-response'
import { PrintingActivity } from '@/model/PrintingActivity'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"

interface ComponentData {
  tableHeight: string,
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean

  printingActivityList: PrintingActivity[]
}

export default Vue.extend({
  name: 'PrintingActivityPage',

  components: {
    AddressWindow,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxStateStoring
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,

      printingActivityList: []
    }
  },

  watch: { },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },
  },

  methods: {
    onResize (): void {
      if(this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 405) {
          this.tableHeight = `height: calc(${vh}px - 105px)`
        } else {
          this.tableHeight = 'height: 300px'
        }
      } else {
        this.tableHeight = 'height: 500px'
      }
    },

    async fetchPrintingActivityList (): Promise<void> {
      try {
        this.loading = true
        const response: PrintingActivityResponse = await this.$store.dispatch(FETCH_PRINTING_ACTIVITY_LIST)
        this.loading = false
        if(!response.IsError && response.Data) {
          this.printingActivityList = PrintingActivity.createListFromResponse(response.Data)
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  mounted (): void {
    this.fetchPrintingActivityList()
  }
})
